import React, { Component } from 'react';
import { gsap } from 'gsap';

import { scenesPropTypes } from './prop-types';
import animationData from '../../lotties/13';
import logo from '../../images/logo-fnr.svg';
import research from '../../images/logo-research-with-impact.svg';
import SceneHeading from '../SceneHeading';
import SceneContent from '../SceneContent';
import SceneSlides from '../SceneSlides';
import Slide from '../Slide';
import SlideText from '../SlideText';
import Icon from '../Icon';
import AudioPlayer from '../Players/AudioPlayer';

/**
 * Scene13
 */

class Scene13 extends Component {
  constructor(props) {
    super(props);

    /** Refs */
    this.element = React.createRef();
    this.heading = React.createRef();
    this.tween = React.createRef();
    this.slides = this.props.data.slides.map(() => React.createRef());
    this.slidesTweens = [];
    this.medias = [];
    this.mediasTweens = [];
    this.props.data.slides.forEach((slide, index) => {
      this.slidesTweens[index] = {};
      if (slide.type === 'media' && slide.audio) {
        this.medias[index] = React.createRef();
        this.mediasTweens[index] = React.createRef();
      }
    });
  }

  /**
   * Invoked after the component is mounted
   */
  componentDidMount() {
    /** Setup a GSAP Tween for each media */
    this.mediasTweens.map((media, index) => (this.slidesTweens[index].media = gsap.from(media.current, { opacity: 0, duration: 1, paused: true })));

    /** Mount the slides tweens to the Scene timeline */
    this.props.mountSlides(this.slides, this.tween.current);
  }

  render() {
    return (
      <div ref={this.element} className="scene-wrapper">
        <SceneHeading ref={this.heading} title={this.props.title} animationData={animationData} />
        <SceneContent layout={this.props.data.layout}>
          <SceneSlides ref={this.tween} align={this.props.data.align} length={this.props.data.slides.length} layout="arrow">
            {this.props.data.slides.map((slide, index) => (
              <Slide key={index} ref={this.slides[index]} type={slide.type} align={slide.align} layout={slide.layout}>
                {slide.type === 'media' && slide.audio && (
                  <div ref={this.mediasTweens[index]}>
                    <AudioPlayer ref={this.medias[index]} url={slide.audio} legend={slide.title} />
                    {slide.text && <SlideText text={slide.text} />}
                  </div>
                )}
                {slide.type === 'link' && slide.link && (
                  <>
                    <div className="scene13-logos">
                      <h3>
                        <a href={slide.link.url} {...(slide.link.target === '_blank' && { target: '_blank', rel: 'noopener noreferrer' })}>
                          <img src={logo} alt="Luxembourg National Research Fund" />
                        </a>
                      </h3>
                      <p>
                        <img src={research} alt="Research with impact" />
                      </p>
                    </div>
                    <p className="scene13-download">
                      <a className="download" href={this.props.downloadLink.url} target="_blank" rel="noopener noreferrer">
                        <Icon icon="arrow-down" layout="l-bg l-bg-blue-pale" /> <b dangerouslySetInnerHTML={{ __html: this.props.downloadLink.title }} />
                      </a>
                    </p>
                    <p className="scene13-button-home">
                      <a href="#" onClick={(event) => this.props.onSceneChange(event, 0)}>
                        <Icon icon="arrow-thin-left" /> {slide.link.title}
                      </a>
                    </p>
                  </>
                )}
              </Slide>
            ))}
          </SceneSlides>
        </SceneContent>
      </div>
    );
  }
}

Scene13.propTypes = scenesPropTypes;

export default Scene13;
